import type { SecondaryMarketTradeWay } from 'api/data-contracts';
import type { LiveQuoteResponse } from 'apiConnector/secondary-market/live/models';
import type { SecondaryPriceType } from 'state/secondaryMarket/productSearch';
import type { Collection } from 'state/utils/types';

export type LiveQuoteStatus =
  | 'QUOTING'
  | 'QUOTED'
  | 'QUOTE_REJECTED'
  | 'QUOTE_FAILED'
  | 'QUOTED_EXPIRED'
  | 'QUOTED_ENDED';

export type QuoteState = Omit<LiveQuoteResponse, 'way' | 'priceUnit'> & {
  quoteStatus: LiveQuoteStatus;
  errorMessage?: string;
  timeout?: number;
  priceType?: SecondaryPriceType;
  tradeWay?: SecondaryMarketTradeWay;
  tradeAuthStartTimeInMillis?: number;
  tradeAuthDurationInMillis?: number;
  greeks?: LiveGreeks[];
};

export type LiveGreeks = Readonly<{
  source?: string;
  underlyingId?: string;
  spot?: number;
  deltaInPercent?: number;
  deltaInAmount?: number;
  gammaInPercent?: number;
  gammaInAmount?: number;
  vegaInAmount?: number;
  vegaInPercent?: number;
  thetaInAmount?: number;
  thetaInPercent?: number;
}>;

export type LiveQuoteMap = Collection<QuoteState>;

export const initialLiveQuote: QuoteState = { quoteStatus: 'QUOTING' };

export const initialLiveQuoteMap = {};
